<nz-drawer
  [nzVisible]="isVisible"
  [nzTitle]="titleTemplate"
  nzPlacement="right"
  [nzClosable]="true"
  (nzOnClose)="onHide()"
  [nzWidth]="drawerWidth"
  class="custom-drawer"
>


  <ng-container *nzDrawerContent>
    <div nz-row nzJustify="space-between" class="notification-read">
      <nz-tabset [nzSelectedIndex]="tabIndex" (nzSelectChange)="tabChange($event)">
        <nz-tab nzTitle="All"></nz-tab>
        <nz-tab nzTitle="Unread"></nz-tab>
      </nz-tabset>
    </div>

    <ng-template #customEmpty>
      <div class="full-page-empty">
        <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="'There are no notifications'"></nz-empty>
      </div>
    </ng-template>

    <div>
      <nz-table [nzData]="response.content"
        [nzLoading]="loading"
        nzShowPagination="false"
        [nzNoResult]="customEmpty"
      >
        <tbody>
          <tr *ngFor="let item of response.content" (click)="openItem(item)" class="notification-item">
            <td [ngStyle]="!item.seen ? {'background-color': '#890C58', 'padding': '2px'} : {'background-color': '#D9D9D9', 'padding': '2px'}"></td>
            <td style="padding-right: 0 !important; padding-left: 7px !important; vertical-align: top">
              <div>
              </div>
              <div [ngSwitch]="item.notificationType" class="ml-8">

                <ng-template [ngSwitchCase]="'SYSTEM'">
                  <div class="news-icon-container system-icon">
                    <div class="icon-wrapper">
                      <i nz-icon nzType="setting" nzTheme="outline"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'NEWS'">
                  <div class="news-icon-container news-icon">
                    <div class="icon-wrapper">
                      <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'CONSENT'">
                  <div class="news-icon-container consent-icon">
                    <div class="icon-wrapper">
                      <i nz-icon nzType="notification" nzTheme="outline"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'APP_UPDATE_REQUIRED'">
                  <div class="news-icon-container update-icon">
                    <div class="icon-wrapper">
                      <i nz-icon nzType="warning" nzTheme="outline"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'APP_EXPIRED'">
                  <div class="news-icon-container expired-icon">
                    <div class="icon-wrapper">
                      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'APP_REJECTED'">
                  <div class="news-icon-container expired-icon">
                    <div class="icon-wrapper">
                      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'APP_REGISTERED'">
                  <div class="news-icon-container registered-icon">
                    <div class="icon-wrapper">
                      <i nz-icon nzType="check-circle" nzTheme="outline"></i>
                    </div>
                  </div>
                </ng-template>

                <ng-template [ngSwitchCase]="'OTHER'">
                  <div class="icon-wrapper">
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                  </div>
                </ng-template>

                <ng-template ngSwitchDefault>
                  <div class="icon-wrapper">
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                  </div>
                </ng-template>
              </div>
            </td>
            <td>
              <p style="font-weight: 600; margin-bottom: 4px; color: #002554E0">{{item.previewTitle}}</p>
              <p style="color: #002554" class="mb-8">{{ item.createdAt | date: 'd MMMM':'':'en-US' }} at {{ item.createdAt | date: 'h:mma' }}</p>
              <p style="color: #002554A6; margin-bottom: 0">{{item.previewBody}}</p>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination *ngIf="response.totalElements > response.size" class="fixed-pagination" [nzPageIndex]="page" [nzTotal]="response.totalElements" [nzPageSize]="response.size"
        (nzPageIndexChange)="pageChange($event)"></nz-pagination>
    </div>

  </ng-container>

</nz-drawer>

<ng-template #titleTemplate>
  <div style="display: flex; align-items: center; justify-content: space-between;">
    <div class="fs-16" style="color: rgba(0, 37, 84, 0.88)">Notifications ({{count}})</div>
    <div (click)="onMarkAllAsRead();" style="font-size: 14px!important; font-weight: 400!important; color: #2F54EB">Mark all as read</div>
  </div>
</ng-template>
